import React from 'react';
import styled from 'styled-components'
import * as R from 'ramda';
import { usePagination, useTable } from 'react-table'

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }

  .pagination {
    padding: 0.5rem;
  }
`

function getBreakupByStage(data) {
  const byStage = R.groupBy((lead) => lead.leadStage)(data);
  const stages = R.keys(byStage);
  let result = { };
  R.forEach((stage) => {
    result[stage] = byStage[stage].length
  })(stages);

  return result;
}

function LeadTable({ data, updateLead, viewLead }) {    
    const columns = React.useMemo(() => [
        {
            Header: 'Date Added',
            accessor: 'dateAdded',
            Cell: (instance) => {
              let dateAdded = instance.row.values.dateAdded;
              return (<div> { R.isNil(dateAdded) ? 'N/A' : new Date(dateAdded*1000).toDateString() } </div>);
            }
        },
        {
          Header: 'Time Added',
          accessor: 'timeAdded',
          Cell: (instance) => {
            let dateAdded = instance.row.values.dateAdded;
            return (<div> { R.isNil(dateAdded) ? 'N/A' : new Date(dateAdded*1000).toTimeString() } </div>);
          }
        },
        {
            Header: 'Lead ID',
            accessor: 'leadId', // accessor is the "key" in the data
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Phone No',
            accessor: 'phoneNo',
        },
        {
            Header: 'Category',
            accessor: 'category'
        },
        {
          Header: 'Lead Stage',
          accessor: 'leadStage'
        },
        {
          Header: 'Target Course',
          accessor: 'targetCourse',
        },
        {
            Header: 'Target Batch',
            accessor: 'targetBatch'
        },
        {
          Header: 'Assigned To',
          accessor: 'assignedTo',
          Cell: (instance) => R.isNil(instance.row.values.assignedTo) ? 'Unassigned' : instance.row.values.assignedTo,
        },
        {
          Header: 'Last Updated By',
          accessor: 'lastUpdatedBy',
          Cell: (instance) =>  R.isNil(instance.row.values.lastUpdatedBy) ? 'N/A' : instance.row.values.lastUpdatedBy
        },
        {
            Header: 'Add Update',
            Cell: (instance) => {
            return (
                <input
                    className="btn btn-primary"
                    type="button"
                    value="Add Update"
                    onClick={() => updateLead(instance.row.values)}
                />
            )}
        },
        {
          Header: 'View Information',
          Cell: (instance) => {
          return (
              <input
                  className="btn btn-success"
                  type="button"
                  value="View"
                  onClick={() => viewLead(instance.row.values)}
              />
          )}
      }
    ], []);
      
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        rows,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }
      } = useTable({ columns, data, initialState: { pageIndex: 0 } }, usePagination);



      return (
        <Styles>
          <div> Total { data.length } entries found </div>
          <div> Stagewise Breakup { `${JSON.stringify(getBreakupByStage(data))}` } </div>
          <table {...getTableProps()} style={{ border: 'solid 1px blue' }}>
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps()}
                      style={{
                        borderBottom: 'solid 3px red',
                        background: 'aliceblue',
                        color: 'black',
                        fontWeight: 'bold',
                      }}
                    >
                      {column.render('Header')}
                      <div>{column.canFilter ? column.render('Filter') : null}</div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()} style={{
                      padding: '10px',
                      border: 'solid 1px gray',
                      background: 'papayawhip',
                    }}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
            })}
              {/* {rows.map(row => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return (
                        <td
                          {...cell.getCellProps()}
                          style={{
                            padding: '10px',
                            border: 'solid 1px gray',
                            background: 'papayawhip',
                          }}
                        >
                          {cell.render('Cell')}
                        </td>
                      )
                    })} */}
                  {/* </tr> */}
                {/* ) */}
              {/* })} */}
            </tbody>
          </table>
          <div className="pagination">
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
          </button>{' '}
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'<'}
          </button>{' '}
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {'>'}
          </button>{' '}
          <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
          </button>{' '}
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>
          <span>
            | Go to page:{' '}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                gotoPage(page)
              }}
              style={{ width: '100px' }}
            />
          </span>{' '}
          <select
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
      </Styles>
    );
}

export default LeadTable;